/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, TableCell } from '@mui/material';
import { TableWidgetV2 } from '../../../../components/v2';
import { moneyFormatter } from 'utils';
import PecasFormulario from './PecasFormulario';

const PecasManutencaoContainer = ({ pecas, onSave, readOnly }) => {
  const [currentPecas, setCurrentPecas] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedPeca, setSelectedPeca] = useState(null);

  useEffect(() => {
    if (pecas) {
      setCurrentPecas(pecas);
    }
  }, [pecas]);

  const renderRows = (p) => (
    <>
      <TableCell>{p.tipoCompraOptionNome}</TableCell>
      <TableCell>{moneyFormatter(p.valor)}</TableCell>
      <TableCell>{p.quantidade}</TableCell>
      <TableCell>{p.descricao}</TableCell>
    </>
  );

  const onDeleteLocal = (id) => {
    const updated = currentPecas.filter((p) => p.id !== id);
    setCurrentPecas(updated);
    onCloseLocal(updated);
  };

  const onCloseLocal = (pecasToRetrieve) => {
    setOpen(false);
    setSelectedPeca(null);
    onSave(pecasToRetrieve || currentPecas);
  };

  const onUpsert = (data) => {
    let updated = [];
    const exists = currentPecas.filter((p) => p.id === data.id);
    if (exists.length > 0) {
      currentPecas.forEach((p) => {
        updated.push(p.id === data.id ? data : p);
      });
    } else {
      updated = [...currentPecas, data];
    }
    setCurrentPecas(updated);
    onCloseLocal(updated);
  };

  const onEdit = (id) => {
    setSelectedPeca(currentPecas.filter((p) => p.id === id)[0]);
    setOpen(true);
  };

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <TableWidgetV2
          rows={currentPecas}
          titles={['Peça', 'Valor', 'Qtd', 'Descrição']}
          headerTitle="Peças"
          deleteMessage="Tem certeza que deseja remover a peça"
          renderRows={renderRows}
          hasRowActions
          onDelete={onDeleteLocal}
          onEdit={onEdit}
          hasAdd={!readOnly}
          showDelete={!readOnly}
          showEdit={!readOnly}
          onAdd={() => setOpen(true)}
          showEmptyState={false}
        />
      </Grid>
      <PecasFormulario
        selectedPeca={selectedPeca}
        open={open}
        onClose={onCloseLocal}
        onSave={onUpsert}
      />
    </>
  );
};

PecasManutencaoContainer.propTypes = {
  pecas: PropTypes.array,
  onSave: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

PecasManutencaoContainer.defaultProps = {
  pecas: [],
  readOnly: false,
};

export default PecasManutencaoContainer;
